import React, {useState} from "react";
import "../General/General.css";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import CancelModal from "../General/Cancel";
import {uploadedFiles} from "../DragAndDrop";
import "../Clients/AddClients.css";
import {useNavigate} from "react-router-dom";
import JiraProjectSearch from "../General/JiraProjectSearch";
import HarvestClientSearch from "../General/HarvestClientSearch";
import {Checkbox, FormControlLabel, Select, TextField} from "@mui/material";
import MenuItem from '@mui/material/MenuItem';
import keycloak from "../../Keycloak";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import InputLabel from "@mui/material/InputLabel";
import DragAndDrop from "../DragAndDrop";
import {showSaveError, showSaveSuccessMessage} from "../toastUtils";
import DragAndDropImages from "../DragAndDropImages";


const Status = [
    {
        value: 0,
        label: "Select status",
    },
    {
        value: 1,
        label: "Active",
    },
    {
        value: 2,
        label: "Inactive",
    },
];
const KYC = [
    {
        value: "0",
        label: "Select status",
    },
    {
        value: "true",
        label: "Yes",
    },
    {
        value: "false",
        label: "No",
    },
];
const countries = [
    {
        value: "0",
        label: "Select country",
    },
    {
        value: "USA",
        label: "United States Of America",
    },
    {
        value: "UK",
        label: "United Kingdom",
    },
    {
        value: "AUS",
        label: "Australia",
    },
    {
        value: "RSA",
        label: "South Africa",
    },
];

export const modules = [
    {
        value: "recruit",
        label: "Recruit"
    },
    {
        value: "insights",
        label: "Insights"
    }
]

const AddClients = () => {
    const [KeyContactPhoneNumber, setPhoneNumber1] = useState('');
    const [valid1, setValid1] = useState(true);

    const handleKeyContactPhoneNumberChange = (value) => {
        setPhoneNumber1(value);
        setValid1(validatePhoneNumber(value));
        data.keyContact.contactNumber = value;
    };

    const [introducerPhoneNumber, setPhoneNumber2] = useState('');
    const [valid2, setValid2] = useState(true);
    const handleIntroducerPhoneNumberChange = (value) => {
        setPhoneNumber2(value);
        setValid2(validatePhoneNumber(value));
        data.introducer.contactNumber = value;
    };

    const validatePhoneNumber = (phoneNumber) => {
        const countryCode = String(phoneNumber).substring(0, 2);
        const phoneNumberPattern = countryCode === "27" ? /^\+?\d{11}$/ : /^\+?[1-9]\d{1,14}$/;

        return phoneNumberPattern.test(phoneNumber);
    };

    const [keyContactEmail, setKeyContactEmail] = useState('');
    const [validKeyContactEmail, setValidKeyContactEmail] = useState(true);

    const [introEmail, setIntroEmail] = useState('');
    const [validIntroEmail, setValidIntroEmail] = useState(true);
    const [companyStatusValue , setCompanyStatus] = useState(0);
    const [kycValue, setKYC] = useState("0");
    const [uploadedImageFiles, setUploadedImageFiles] = useState(null);
    const [countryValue, setCountry] = useState("0");
    console.log(countryValue, "Testing Country Value");

    const handleIntroducerEmailChange = e => {
        setIntroEmail(e.target.value);
        setValidIntroEmail(validateEmail(e.target.value));
        handleChange(e);
    }
    const handleKeyContactEmailChange = e => {
        setKeyContactEmail(e.target.value);
        setValidKeyContactEmail(validateEmail(e.target.value));
        handleChange(e);
    }

    const validateEmail = (email) => {
        return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
    }

    const navigate = useNavigate();
    const [openModal, setOpenModal] = useState(false);

    const style = {
        "& label.Mui-focused": {
            color: "#FF6600",
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: "#FF6600",
            },
        },
    };

    const [data, setData] = useState({
        harvestClientId: 0,
        clientName: "",
        jiraProjectId: 0,
        businessName: "",
        registrationNum: "",
        companyStatus: 0,
        kycValidated: false,
        address: {
            addressLine1: "",
            addressLine2: "",
            country: "",
            province: "",
            postalCode: 0,
            type: "Physical",
        },
        keyContact: {
            name: "",
            surname: "",
            email: "",
            contactNumber: "",
            employmentRole: ""
        },
        introducer: {
            name: "",
            surname: "",
            email: "",
            contactNumber: "",
            terms: ""
        },
        documents: [],
        clientModules: {
            recruit: false,
            insights: false
        },
        companyLogo: {
            imageName: "",
            fileTpe: "",
            imageBytes: null},
    });

    const handleCheckboxChange = (event, value) => {
        setData((prevData) => ({
            ...prevData,
            clientModules: {
                ...prevData.clientModules,
                [value] : event.target.checked
            }
        }));
    };

    const handleChange = e => {
        // Fetch name and value from changed element
        let {name, value} = e.target;

        if(e.target.name === "companyStatus") {
            setCompanyStatus(e.target.value);
        } else if(e.target.name === "kycValidated") {
            setKYC(e.target.value);
        } else if(e.target.name === "address.country") {
            setCountry(e.target.value);
        }

        // If the name includes ".", it is a nested object
        if (name.includes(".")) {
            // Get the nested attribute
            const [nestedObject, nestedProperty] = name.split(".", 2);

            // Update the value and name to accommodate nested objects
            value = assignPartialObject(data[nestedObject], {[nestedProperty]: value});
            name = nestedObject;
        }

        // Update the state of the form data
        setData({...data, [name]: value})
    }

    const handleCompanyLogoUpload = (files) => {
        setUploadedImageFiles(files);
        console.log("company logo updated");
    };



    /**
     * Add or update only some of the attributes of an existing object.
     *
     * @param existingObject
     * @param newObject
     * @returns object
     */
    const assignPartialObject = (existingObject, newObject) => {
        return Object.assign(existingObject, newObject);
    }

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 50,
            },
        },
    };

    const createNewClient = async (event) => {
        event.preventDefault();

        try {
            console.log(data);
            const headers = new Headers();
            headers.append('Authorization', 'Bearer ' + keycloak.token);
            headers.append('Content-Type', 'application/json');

            // Append company logo if it exists
            if (uploadedImageFiles && uploadedImageFiles.length > 0) {
                for (const file of uploadedImageFiles) {
                    const fileBytes = await readFileAsArrayBuffer(file);
                    data.companyLogo = {
                        imageName: file.name,
                        fileTpe: file.type,
                        imageBytes: Array.from(new Uint8Array(fileBytes)),
                    };
                }
            }else {
                data.companyLogo = null;
            }

            // Handle other uploaded files
            if (uploadedFiles && uploadedFiles.length > 0) {
                for (const file of uploadedFiles) {
                    const fileBytes = await readFileAsArrayBuffer(file);
                    data.documents.push({
                        fileName: file.name,
                        fileType: file.type,
                        fileBytes: Array.from(new Uint8Array(fileBytes)),
                    });
                }
            } else {
                data.documents = [];
            }

            console.log(data);

            const response = await fetch("api/client", {
                method: "POST",
                body: JSON.stringify(data),
                headers: headers,
            });

            if (response.ok) {
                showSaveSuccessMessage("New client has been added successfully");
                navigate("/ClientList");
                const data = await response.json();
                console.log(data);
                console.log("All required fields filled in");
            } else {
                const error = await response.text();
                console.log(error);
                showSaveError(`The client ${data.clientName} already exists.`);
            }

        } catch (error) {
            console.log(error);
            showSaveError("An error occurred, please try again");
            window.scrollTo(0, 0);
        }
    };

    function readFileAsArrayBuffer(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                resolve(reader.result);
            };
            reader.onerror = (error) => {
                reject(error);
            };
            reader.readAsArrayBuffer(file);
        });
    }

    const setJiraProjectId = jiraProjectId => {
        data.jiraProjectId = jiraProjectId;
        console.log('argument from Child: ', data.jiraProjectId);
        console.log(data);
    };

    const setHarvestClientId = (harvestClientId, harvestClientName) => {
        data.harvestClientId = harvestClientId;
        data.clientName = harvestClientName;
        console.log("Harvest client id: ", data.harvestClientId);
        console.log("client name: ", data.clientName);
        console.log(data)
    };

    return (
        <div data-testid='OuterMostDiv' className="OuterMostDiv outerMostDivContainer">
            <div>
                <form onSubmit={createNewClient} enctype="multipart/form-data" method="POST">

                    <Grid container direction="column" justifyContent={"flex-start"} alignItems={"stretch"} spacing={2}
                          className="gridPadding">

                        <Grid item xs={2}></Grid>
                        <Grid item xs={10}>
                            <h4 data-testid='AddClientHeading'> Add a new client</h4>
                        </Grid>

                        <Box sx={{flexGrow: 1}}
                             xs={12}
                             className="box-formatting"
                        >

                            <Paper
                                className="cardWidth"
                                elevation={4}
                            >
                                <h4>Modules</h4>

                                <Grid container direction="row" justifyContent={"flex-start"} alignItems={"stretch"}
                                      spacing={2} padding={3}>
                                    {modules.map((option) => (
                                        <Grid item xs={2} key={option.value}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox data-testid={`select-module-checkbox-${option.value}`}
                                                              checked={data.clientModules[option.value]}
                                                              sx={{
                                                                  '&.Mui-checked': {
                                                                      color: "#FF6600",
                                                                  },
                                                              }}
                                                              onChange={(e) => handleCheckboxChange(e, option.value)}
                                                    />
                                                }
                                                label={option.label}
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                            </Paper>

                            <Paper className="Paper cardWidth elevation1" elevation={1}>
                                <h4>Basic details</h4>
                                <Grid container direction="column" justifyContent={"flex-start"} alignItems={"stretch"}
                                      spacing={2} padding={5} className="ParagraphPadding">
                                    <Grid item xs={12} data-testid='HarvestClientSearchBox' hidden={data.clientModules.recruit && !data.clientModules.insights}>
                                        <HarvestClientSearch harvestClientId={0} harvestClientName={""}
                                                             className="inputWidth"
                                                             onChangeMethod={setHarvestClientId}
                                                             id={"harvestClientSearch"}/>
                                    </Grid>
                                    <Grid item xs={12} data-testid='JiraProjectSearchBox' hidden={data.clientModules.recruit && !data.clientModules.insights}>
                                        <JiraProjectSearch jiraProjectId={0}
                                                           hidden={data.clientModules.recruit}
                                                           jiraProjectName={""}
                                                           onChangeMethod={setJiraProjectId} id={"jiraProjectSearch"}/>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            className="inputWidth"
                                            id="businessName"
                                            sx={style}
                                            label="Legal Business name*"
                                            onChange={e => handleChange(e)}
                                            name={"businessName"}
                                            data-testid={"businessName"}
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            className="inputWidth"
                                            id="registrationNum"
                                            sx={style}
                                            onChange={e => handleChange(e)}
                                            name={"registrationNum"}
                                            data-testid={"registrationNum"}
                                            label="Business registration number*"
                                            variant="outlined"
                                        />{" "}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl sx={style} className="inputWidth">
                                            <InputLabel id="demo-multiple-name-label" sx={{style}}>
                                                Company Status*
                                            </InputLabel>
                                            <Select
                                                id="companyStatus"
                                                sx={style}
                                                select
                                                value={companyStatusValue}
                                                MenuProps={MenuProps}
                                                label="Company Status*"
                                                onChange={e => handleChange(e)}
                                                name={"companyStatus"}
                                            >
                                                {Status.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl sx={style} className="inputWidth">
                                            <InputLabel id="demo-multiple-name-label" sx={{style}}>
                                                KYC Validated*
                                            </InputLabel>
                                            <Select
                                                sx={style}
                                                id="kycValidated"
                                                select
                                                MenuProps={MenuProps}
                                                value={kycValue}
                                                label="KYC Validated?"
                                                onChange={e => handleChange(e)}
                                                name={"kycValidated"}
                                            >
                                                {KYC.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Paper>
                            <Paper
                                elevation={2}
                                className="cardWidth"
                                style={{
                                    height: "498px",
                                }}
                            >
                                <h4>Company Address</h4>

                                <Grid container direction="column" justifyContent={"flex-start"} alignItems={"stretch"}
                                      spacing={2} padding={5} className="ParagraphPadding">
                                    <Grid item xs={12}>
                                        <TextField
                                            sx={style}
                                            className="inputWidth"
                                            id="addressLine1"
                                            label="Address Line 1 *"
                                            placeholder={"Address line 1 *"}
                                            onChange={e => handleChange(e)}
                                            name={"address.addressLine1"}
                                            variant="outlined"
                                            style={{width: "80%"}}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            className="inputWidth"
                                            sx={style}
                                            id="addressLine2"
                                            label="Address Line 2 *"
                                            onChange={e => handleChange(e)}
                                            name={"address.addressLine2"}
                                            placeholder={"Address line 2 *"}
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl sx={style} className="inputWidth">
                                            <TextField
                                                sx={style}
                                                id="country"
                                                MenuProps={MenuProps}
                                                value={countryValue}
                                                select
                                                label="Country*"
                                                onChange={e => handleChange(e)}
                                                name={"address.country"}
                                            >
                                                {countries.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </FormControl>
                                    </Grid>
                                    <Grid item={12}>
                                        <TextField
                                            sx={style}
                                            className="inputWidth"
                                            id="province"
                                            label="Province/State *"
                                            placeholder={"Select province/state"}
                                            onChange={e => handleChange(e)}
                                            name={"address.province"}
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            sx={style}
                                            className="inputWidth"
                                            id="postalCode"
                                            label="Postal Code *"
                                            placeholder="Enter Postal Code"
                                            onChange={e => handleChange(e)}
                                            name={"address.postalCode"}
                                            variant="outlined"
                                        />{" "}
                                    </Grid>
                                </Grid>
                            </Paper>

                            <Paper
                                className="cardWidth"
                                elevation={3}
                                style={{
                                    height: "505px",
                                }}
                            >
                                <h4>Key Contact</h4>

                                <Grid container direction="column" justifyContent={"flex-start"} alignItems={"stretch"}
                                      spacing={2} padding={5} className="ParagraphPadding">
                                    <Grid item xs={12}>
                                        <TextField
                                            id="keyContactName"
                                            label="Name *"
                                            sx={style}
                                            className="inputWidth"
                                            onChange={e => handleChange(e)}
                                            name={"keyContact.name"}
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            id="keyContactSurname"
                                            sx={style}
                                            className="inputWidth"
                                            label="Surname *"
                                            onChange={e => handleChange(e)}
                                            name={"keyContact.surname"}
                                            variant="outlined"
                                        />{" "}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            id="keyContactEmail"
                                            sx={style}
                                            className="inputWidth"
                                            label="Email Address *"
                                            data-testid={"keyEmail"}
                                            name={"keyContact.email"}
                                            variant="outlined"
                                            inputProps={{
                                                required: true,
                                            }}
                                            value={keyContactEmail}
                                            onChange={handleKeyContactEmailChange}
                                        />
                                        {!validKeyContactEmail && (
                                            <p className={"text-danger"}>Please enter a valid email address.</p>
                                        )}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <PhoneInput
                                            className="inputWidth"
                                            sx={style}
                                            name={"keyContact.contactNumber"}
                                            containerStyle={{
                                                width: "100%",
                                                border: "#FF6600",
                                                color: "#FF6600",
                                            }}
                                            inputStyle={{
                                                width: "100%",
                                                height: "57px"
                                            }}
                                            id="keyContactNumber"
                                            variant="outlined"
                                            country={'za'}
                                            inputProps={{
                                                required: true,
                                            }}
                                            value={KeyContactPhoneNumber}
                                            onChange={handleKeyContactPhoneNumberChange}
                                        />
                                        {!valid1 && (
                                            <p className={"text-danger"}>Please enter a valid phone number.</p>
                                        )}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            className="inputWidth"
                                            id="keyContactEmploymentRole"
                                            label="Employment role *"
                                            onChange={e => handleChange(e)}
                                            name={"keyContact.employmentRole"}
                                            sx={style}
                                            variant="outlined"
                                        />
                                    </Grid>
                                </Grid>
                            </Paper>
                            <Paper
                                className="cardWidth"
                                elevation={4}
                                style={{
                                    height: "507px",
                                }}
                            >
                                <h4>Introducer</h4>

                                <Grid container direction="column" justifyContent={"flex-end"} alignItems={"stretch"}
                                      spacing={2} padding={5} className="ParagraphPadding">
                                    <Grid item xs={12}>
                                        <TextField
                                            className="inputWidth"
                                            sx={style}
                                            id="introducerName"
                                            onChange={e => handleChange(e)}
                                            name={"introducer.name"}
                                            label="Name"
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            className="inputWidth"
                                            sx={style}
                                            id="introducerSurname"
                                            label="Surname"
                                            onChange={e => handleChange(e)}
                                            name={"introducer.surname"}
                                            variant="outlined"
                                        />{" "}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            className="inputWidth"
                                            sx={style}
                                            id="introducerEmail"
                                            label="Email Address"
                                            variant="outlined"
                                            name={"introducer.email"}
                                            value={introEmail}
                                            data-testid={"introEmail"}
                                            onChange={handleIntroducerEmailChange}
                                        />
                                        {!validIntroEmail && (
                                            <p className={"text-danger"}>Please enter a valid email address.</p>
                                        )}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <PhoneInput
                                            className="inputWidth"
                                            sx={style}
                                            name={"introducer.contactNumber"}
                                            containerStyle={{
                                                width: "100%",
                                                border: "#FF6600",
                                                color: "#FF6600",
                                            }}
                                            inputStyle={{
                                                width: "100%",
                                                height: "57px"
                                            }}
                                            id="introducerContactNumber"
                                            variant="outlined"
                                            country={'za'}
                                            inputProps={{
                                                required: true,
                                            }}
                                            value={introducerPhoneNumber}
                                            onChange={handleIntroducerPhoneNumberChange}
                                        />
                                        {!valid2 && (
                                            <p className={"text-danger"}>Please enter a valid phone number.</p>
                                        )}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            onChange={e => handleChange(e)}
                                            name={"introducer.terms"}
                                            className="inputWidth"
                                            sx={style}
                                            id="introducerTerms"
                                            label="Terms"
                                            variant="outlined"
                                        />
                                    </Grid>
                                </Grid>
                            </Paper>

                            <Paper
                                className="cardWidth"
                                elevation={4}
                                style={{
                                    height: "507px",
                                }}
                            >
                                <h4>HR Contact</h4>

                                <Grid container direction="column" justifyContent={"flex-end"} alignItems={"stretch"}
                                      spacing={2} padding={5} className="ParagraphPadding">
                                    <Grid item xs={12}>
                                        <TextField
                                            className="inputWidth"
                                            sx={style}
                                            id="hrName"
                                            onChange={e => handleChange(e)}
                                            name={"hr.name"}
                                            label="Name"
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            className="inputWidth"
                                            sx={style}
                                            id="hrSurname"
                                            label="Surname"
                                            onChange={e => handleChange(e)}
                                            name={"hr.surname"}
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            className="inputWidth"
                                            sx={style}
                                            id="hrEmail"
                                            label="Email Address"
                                            variant="outlined"
                                            name={"hr.email"}
                                            data-testid={"hrEmail"}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <PhoneInput
                                            className="inputWidth"
                                            sx={style}
                                            name={"hr.contactNumber"}
                                            containerStyle={{
                                                width: "100%",
                                                border: "#FF6600",
                                                color: "#FF6600",
                                            }}
                                            inputStyle={{
                                                width: "100%",
                                                height: "57px"
                                            }}
                                            id="hrContactNumber"
                                            variant="outlined"
                                            country={'za'}
                                            inputProps={{
                                                required: true,
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Paper>

                            <Paper
                                className="cardWidth"
                                elevation={5}
                                style={{
                                    height: "294px",
                                }}
                            >
                                <h4>Agreements & Documents</h4>
                                <DragAndDrop inputUpdated={() => {console.log("document added")}}/>
                            </Paper>
                            <Paper
                                className="cardWidth"
                                elevation={5}
                                style={{
                                    height: "294px",
                                }}
                            >
                                <h4>Company Logo</h4>
                                <DragAndDropImages
                                    inputUpdated={handleCompanyLogoUpload}
                                    allowedFileTypes={['SVG', 'PNG', 'JPG', 'GIF']}
                                    maxFileSize={3 * 1024 * 1024} // 3MB
                                />
                            </Paper>
                        </Box>
                        <Box style={{ marginTop: "20px" }} xs={12}>
                            <Paper
                                className="cardWidth" style={{ backgroundColor: "#F6F6F6", border: "0"}}>
                                <div className="d-inline-block float-end buttonPadding editSaveButtonPadding">
                                    <button
                                        type="submit"
                                        data-testid={"save-button"}
                                        variant="contained"
                                        className="SaveButton"
                                    >
                                        {" "}
                                        SAVE
                                    </button>
                                </div>
                                <div className="d-inline-block float-end buttonPadding editCancellButtonPadding">
                                    <button
                                        className="CancelButton"
                                        variant="outlined"
                                        onClick={() => {
                                            setOpenModal(true);
                                        }}
                                    >
                                        CANCEL
                                    </button>
                                    <CancelModal
                                        open={openModal}
                                        onClose={() => setOpenModal(false)}
                                    />
                                </div>
                            </Paper>
                        </Box>
                    </Grid>
                </form>
            </div>
        </div>
    );
};

export default AddClients;

